import { Accordion as MuiAccordion, styled } from '@mui/material';

export const Accordion = styled(MuiAccordion)({
  boxShadow: 'none',
});
